import { HundredBookChallengeModule } from 'components/100-book-challenge/Modules'
import ENILPracticeCards from 'components/arc-core/ENILPracticeCards'
import Framework from 'components/arc-core/Framework'
import HomeCoachMagnets from 'components/arc-core/HomeCoachMagnets'
import HundredBookChallenge from 'components/arc-core/HundredBookChallenge'
import IncentiveMedals from 'components/arc-core/IncentiveMedals'
import IRLAPracticeCards from 'components/arc-core/IRLAPracticeCards'
import LogBooks from 'components/arc-core/LogBooks'
import MaterialItem from 'components/arc-core/MaterialItem'
import PreKReadAlouds from 'components/arc-core/PreKReadAlouds'
import SuperReaderCape from 'components/arc-core/SuperReaderCape'
import TakeHomeBookBags from 'components/arc-core/TakeHomeBookBags'
import TeacherResourceKit from 'components/arc-core/TeacherResourceKit'
import TeacherResourceKitSpanish from 'components/arc-core/TeacherResourceKitSpanish'
import { Col, Container, Row } from 'components/grid'
import React from 'react'

interface Props {
	data: HundredBookChallengeModule
	language: 'english' | 'spanish'
	showFrameworks?: boolean
}

export default function Module({ data, language, showFrameworks }: Props) {
	return (
		<Container>
			<Row className="pt-10" center>
				{data.framework.cover && (
					<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
						{showFrameworks ? (
							<Framework image={data.framework.cover.gatsbyImageData} fullFramework={data.framework.document.file.url} updatedAt={data.framework.updatedAt} />
						) : (
							<MaterialItem image={data.framework.cover.gatsbyImageData} name="Framework for Best Practices" />
						)}
					</Col>
				)}
				{data.name !== 'Pre-K' && data.name !== 'Prekínder' ? (
					<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
						{language === 'english' ? <TeacherResourceKit /> : <TeacherResourceKitSpanish />}
					</Col>
				) : null}
				<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
					{language === 'english' ? <IRLAPracticeCards grade={determineGradeRange(data.name)} /> : <ENILPracticeCards grade={determineGradeRange(data.name)} />}
				</Col>

				<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
					<TakeHomeBookBags grade={determineGradeRange(data.name)} />
				</Col>
				{getsK1Materials(data.name) ? (
					<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
						<LogBooks language={language} />
					</Col>
				) : null}
				{data.name === 'Pre-K' || data.name === 'Prekínder' ? (
					<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
						<PreKReadAlouds language={language} />
					</Col>
				) : null}
				{getsK1Materials(data.name) ? (
					<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
						<SuperReaderCape />
					</Col>
				) : null}
				{data.name !== 'High School' ? (
					<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
						<IncentiveMedals />
					</Col>
				) : null}
				{data.name === 'Pre-K' || data.name === 'Prekínder' ? null : (
					<Col width={`w-1/2 ${determineColWidth(data.name)}`} className="mb-10">
						<HomeCoachMagnets language={language} />
					</Col>
				)}
			</Row>
			<Row className={`${data.name === 'Pre-K' || data.name === 'Prekínder' ? 'mx-auto max-w-screen-md' : ''}`}>
				<HundredBookChallenge baskets={data.leveledLibrary} maxBaskets={10} />
			</Row>
		</Container>
	)
}

function determineGradeRange(name: string) {
	if (name === 'Pre-K' || name === 'Prekínder') return 'pre-k'
	if (name === 'Grade K' || name === 'Grade 1' || name === 'Grado K' || name === 'Grado 1') return 'k-2'
	if (name === 'Grades 2-3' || name === 'Grades 4-5' || name === 'Grados 2-3' || name === 'Grados 4-5') return '3-5'
	if (name === 'Grades 6-8' || name === 'Grados 6-8') return '6-8'
	if (name === 'High School') return 'hs'
	else return 'k-2'
}

function determineColWidth(name: string) {
	if (name === 'Pre-K' || name === 'Prekínder' || name === 'Grade K' || name === 'Grado K' || name === 'Grade 1' || name === 'Grado 1') return 'md:w-1/4'
	else return 'md:w-1/3'
}

function getsK1Materials(name: string) {
	if (name === 'Pre-K' || name === 'Prekínder' || name === 'Grade K' || name === 'Grado K' || name === 'Grade 1' || name === 'Grado 1') return true
	else return false
}
